import React, { type InputHTMLAttributes } from 'react';
import { Wrapper, Input, Indicator } from './view';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    checked?: boolean;
    className?: string;
    disabled?: boolean;
    cy?: string;
}

const SlideSelector = ({ className, disabled, cy, ...rest }: Props) => (
    <Wrapper className={className}>
        <Input
            type="checkbox"
            disabled={disabled}
            data-cy={cy}
            {...rest}
        />
        <Indicator disabled={disabled} />
    </Wrapper>
);

SlideSelector.displayName = 'SlideSelector';

export default SlideSelector;
